import React from 'react'
import {
  IconButton,
  OutlinedInput,
  InputLabel,
  InputAdornment,
  FormControl,
  FormHelperText
} from '../../Atoms'
import { VisibilityOff, Visibility } from '@material-ui/icons'
import { t as i18n } from 'ttag'
import PropTypes from 'prop-types'

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /** The value of the Input element, required for a controlled component. **/
  value: PropTypes.any,
  /** Callback fired when the value is changed. **/
  onChange: PropTypes.func,
  /** If true, the label will be displayed in an error state. **/
  error: PropTypes.bool
}

const defaultProps = {
  error: false
}

/**
 * ## PasswordField
 */

const PasswordField = props => {
  const { value, onChange, id } = props

  const [values, setValues] = React.useState({
    password: '',
    showPassword: false,
    error: false,
    helperText: i18n`Enter your password`
  })

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword })
  }

  const passwordText = i18n`Password`

  return (
    <FormControl
      variant='outlined'
      fullWidth
      error={props.error}
      required
      margin='normal'
      data-cid='PasswordField-root'
    >
      <InputLabel htmlFor='password'>{passwordText}</InputLabel>
      <OutlinedInput
        id={id}
        autoComplete='current-password'
        type={values.showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        labelWidth={passwordText.length * 10}
        style={{
          paddingRight: 0
        }}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label={i18n`Toggle password visibility`}
              onClick={handleClickShowPassword}
            >
              {values.showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      {props.error ? <FormHelperText children={values.helperText} /> : null}
    </FormControl>
  )
}

PasswordField.propTypes = propTypes
PasswordField.defaultProps = defaultProps

export default PasswordField
